@if (fileName) {
  <img
    src="{{ imgUrl }}"
    alt="{{ fileType }} download"
    (click)="getFile()"
    />
}
@if (!fileName) {
  <span container="body" class="float-left">
    {{ fileType }} Not Ready For Download
  </span>
}
